"use client";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import LoadingFullScreen from '../components/Layout/Loading';

const SplashScreen: React.FC = () => {
  const { validateToken } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem('token');
      
      if (token) {
        // Validar el token existente
        const isValid = await validateToken(token);
        if (isValid) {
          // Si el token es válido, redirigir a la página principal
          navigate('/store', { replace: true });
        } else {
          // Si el token no es válido, redirigir al login
          navigate('/login', { replace: true });
        }
      } else {
        // Si no hay token, redirigir al login después de un breve retraso
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 1500); // Mostrar la pantalla de carga por 1.5 segundos
      }
    };

    checkToken();
  }, [navigate, validateToken]);

  return (
    <LoadingFullScreen />
  );
};

export default SplashScreen;
